/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Load_RequiredInputs */

const en_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a preset`)
};

const fr_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner un préréglage`)
};

const de_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Voreinstellung aus.`)
};

const it_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset`)
};

const ru_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите предустановку`)
};

const es_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor seleccione un ajuste preestablecido`)
};

const zh_cn2_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请选择预设值`)
};

const ja_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択してください`)
};

const hi_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक प्रीसेट चुनें`)
};

const pt_pt2_subtitle_export_preset_load_required = /** @type {(inputs: Subtitle_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione uma predefinição.`)
};

/**
* | output |
* | --- |
* | "Please select a preset" |
*
* @param {Subtitle_Export_Preset_Load_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_load_required = /** @type {((inputs?: Subtitle_Export_Preset_Load_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Load_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_load_required(inputs)
	if (locale === "de") return de_subtitle_export_preset_load_required(inputs)
	if (locale === "it") return it_subtitle_export_preset_load_required(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_load_required(inputs)
	if (locale === "es") return es_subtitle_export_preset_load_required(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_load_required(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_load_required(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_load_required(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_load_required(inputs)
	return en_subtitle_export_preset_load_required(inputs)
});